import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Dashboard from './pages/Dashboard/Dashboard';
import Measurements from './pages/Measurements/Measurements';
import Login from './pages/Onboarding/Login';
import Projects from './pages/Projects/Projects';
import ProjectPage from './pages/Projects/ProjectPage';
import UploadFile from './utils/UploadFile';
import SettingsPage from './pages/Settings/SettingsPage';
import SignUp from './pages/Onboarding/SignUp';
import InviteHandler from './utils/InviteHandler';
import ResetPassword from './pages/Settings/ResetPassword';
import ForgotPassword from './pages/Settings/ForgotPassword';
import { UserProvider } from './context/UserContext.js';
import { AuthProvider } from './context/AuthContext.js'; // Import AuthProvider
import ProjectList from './pages/Projects/ProjectList';
import MappedProject from './pages/Projects/MappedProject.js';
import UnmappedProject from './pages/Projects/UnmappedProject.js';
import Landing from './pages/Website/landing.js';
import Whitelist from './pages/Website/whitelist.js';
import { Analytics } from "@vercel/analytics/react"
import Analysis from './pages/Analysis/Analysis.js';
import Upload from './pages/Upload/Upload.js';
import Integrations from './pages/Website/integrations.js'
import Pricing from './pages/Website/pricing.js';
import Demo from './pages/Website/demo.js';
import MeasurementHQ from './pages/Measurements/MeasurementHQ.js';
import HQDemo from './pages/Website/hqDemo.js';
import OnboardingWizard from './pages/Onboarding/OnboardingWizard.js';

export default function App() {
  return (
    <AuthProvider>
      <UserProvider>
        <Router>
          <Analytics />
          <Routes>
            {/* Public routes */}
            <Route path="/" element={<Landing />} />
            <Route path="/whitelist" element={<Whitelist />} />
            <Route path="/login" element={<Login />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/measurements" element={<Measurements />} />
            {/* <Route path="/upload" element={<UploadFile />} /> */}
            <Route path="/settings/:tab" element={<SettingsPage />} />
            <Route path="/settings" element={<SettingsPage />} />
            <Route path="/signup" element={<SignUp />} />
            <Route path="/invite" element={<InviteHandler />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/projects" element={<ProjectList />} />
            <Route path="/project/:projectId" element={<MappedProject />} />
            <Route path="/unmappedproject" element={<UnmappedProject />} />
            <Route path="/analysis" element={<Analysis />} />
            <Route path="/upload" element={<Upload />} />
            <Route path="/integrations" element={<Integrations />} />
            <Route path='/pricing' element={<Pricing />} />
            <Route path='/demo' element={<Demo />} />
            <Route path="/measurementhq" element={<MeasurementHQ />} />
            <Route path="/hqdemo" element={<HQDemo />} />
            <Route path="/onboarding" element={<OnboardingWizard />} />
            
          </Routes>
        </Router>
      </UserProvider>
    </AuthProvider>
  );
}